import {BaseAddressUnDeletable} from '../../../common/entities';

export class MilitaryBase extends BaseAddressUnDeletable {
    name: string;
}
